var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"page-login-video-stream-button",attrs:{"type":"primary","disabled":_vm.disabled},domProps:{"textContent":_vm._s(_vm.$tt('activate_webcam'))},on:{"click":_vm.dispatchClickEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }